import { toast as sonnerToast } from 'sonner';

type ToastAction = {
  label: string;
  onClick: () => void;
};

type ToastOptions = {
  description?: string;
  duration?: number;
  className?: string;
  action?: ToastAction;
};

function resolveOptions(
  descriptionOrOptions?: string | ToastOptions,
  options?: ToastOptions
): ToastOptions {
  if (typeof descriptionOrOptions === 'string') {
    return {
      ...(options || {}),
      description: descriptionOrOptions,
    };
  }
  return descriptionOrOptions || options || {};
}

// Wrapper around sonner toast for consistent styling
export const toast = {
  success: (message: string, descriptionOrOptions?: string | ToastOptions, options?: ToastOptions) => {
    const resolved = resolveOptions(descriptionOrOptions, options);
    const toastOptions: any = {
      duration: 3000,
      className: 'bg-green-50 border-green-200 text-green-900',
      ...resolved,
    };
    sonnerToast.success(message, toastOptions);
  },
  
  error: (message: string, descriptionOrOptions?: string | ToastOptions, options?: ToastOptions) => {
    const resolved = resolveOptions(descriptionOrOptions, options);
    const toastOptions: any = {
      duration: 4000,
      className: 'bg-red-50 border-red-200 text-red-900',
      ...resolved,
    };
    sonnerToast.error(message, toastOptions);
  },
  
  info: (message: string, descriptionOrOptions?: string | ToastOptions, options?: ToastOptions) => {
    const resolved = resolveOptions(descriptionOrOptions, options);
    const toastOptions: any = {
      duration: 3000,
      className: 'bg-blue-50 border-blue-200 text-blue-900',
      ...resolved,
    };
    sonnerToast.info(message, toastOptions);
  },
  
  warning: (message: string, descriptionOrOptions?: string | ToastOptions, options?: ToastOptions) => {
    const resolved = resolveOptions(descriptionOrOptions, options);
    const toastOptions: any = {
      duration: 3500,
      className: 'bg-purple-50 border-purple-200 text-purple-900',
      ...resolved,
    };
    sonnerToast.warning(message, toastOptions);
  },
  
  loading: (message: string) => {
    return sonnerToast.loading(message);
  },
  
  dismiss: (toastId: string | number) => {
    sonnerToast.dismiss(toastId);
  },
};
